<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form class="t-application-invite-user-payment__form" @submit.prevent="handleSubmitForm">
      <div class="t-application-invite-user-payment__fields">
        <div class="t-application-invite-user-payment__options">
          <m-payment-radio
            v-model="formData.payment_method"
            v-model:card-number="formData.card_number"
            v-model:card-expiry="formData.card_expiry"
            v-model:card-holder="formData.card_holder"
            v-model:card-cvv="formData.card_cvv"
            label="クレジットカードによる支払い"
            name="payment_method"
            value="credit-card"
            type="credit-card"
          />
          <m-payment-radio
            v-model="formData.payment_method"
            v-model:invoice-address="formData.invoice_address"
            v-model:invoice-phone="formData.invoice_phone"
            v-model:invoice-street="formData.invoice_street"
            v-model:invoice-same-address="formData.invoice_same_address"
            label="請求書による支払い"
            sublabel="同封の申し込み書の送付によって口座振替も可能です。"
            name="payment_method"
            value="invoice"
            type="invoice"
          />
        </div>
      </div>
      <div class="t-application-invite-user-payment__buttons">
        <m-button-container>
          <a-button variant="block" submit="submit" color="primary" :disabled="!formData.payment_method">次へ</a-button>
          <a-button color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import MPaymentRadio from '@/components/molecules/payment-radio';
import { cloneDeep } from 'lodash';

export default {
  name: 't-application-invite-user-payment',
  components: {
    TDefaultEntrySidebar,
    MPaymentRadio,
    AButton,
    MButtonContainer,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    sidebarInfo: {
      type: Object,
      default: null,
    },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        payment_method: null,
        card_number: '',
        card_expiry: '',
        card_holder: '',
        card_cvv: '',
        invoice_address: '',
        invoice_phone: '',
        invoice_street: '',
        invoice_same_address: true,
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-payment');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleSubmitForm(e) {
      e.preventDefault();
      const data = cloneDeep(this.formData);
      const payload = {
        payment_method: data.payment_method,
      };
      if (data.payment_method === 'invoice') {
        payload.invoice_address = data.invoice_address;
        payload.invoice_phone = data.invoice_phone;
        payload.invoice_street = data.invoice_street;
        payload.invoice_same_address = data.invoice_same_address;
      } else {
        payload.card_number = data.card_number;
        payload.card_expiry = data.card_expiry;
        payload.card_holder = data.card_holder;
        payload.card_cvv = data.card_cvv;
      }
      this.handleFormSubmit(cloneDeep(payload));
    },
  },
};
</script>
